import BaseAPI from "api/BaseAPI";

class DashboardAPI extends BaseAPI {
	
	
	getDashboard = async (params) => {
		var promise = await this.init().get("/account/dashboard", { params: params });
		return promise;
	};
	
}

export default new DashboardAPI();